import { assignInlineVars } from "@vanilla-extract/dynamic";
import clsx from "clsx";
import type { PropsWithChildren } from "react";
import { gridCols, stack } from "./HStack.css";
import type { Props } from "./types";

export default function Stack({
	className,
	gridColumns,
	columns,
	children,
	style,
}: PropsWithChildren<Props>) {
	const gridTemplateColumns =
		gridColumns ??
		(columns ? Array.from({ length: columns }, () => "1fr").join(" ") : "1fr");
	return (
		<div
			className={clsx(stack, className)}
			style={{
				...assignInlineVars({
					[gridCols]: gridTemplateColumns,
				}),
				...style,
			}}
		>
			{children}
		</div>
	);
}
